import initApplication from './plugins/app'
import initBody from './plugins/body'
import initCP from './plugins/cp'
import initCore from './plugins/core'
import initGinger from './plugins/ginger'
import initGmap from './plugins/gmap'
import initI18N from './plugins/i18n'
import initLocal from './plugins/local'
import initModules from './plugins/modules'
import initReset from './plugins/reset'

import eventbus from './eventbus'
import router from './router'
import store from './store'
import { cp, http, states } from './data'
import moment from 'moment'

const transports = { cp, http };
const capacities = {
  debug: false,
  eventbus,
  router,
  states,
  store,
  transports
}

const VueBootstrap = {};
let options = {};

VueBootstrap.install = (Vue) => {
  Vue.prototype.$bus = eventbus;
  Vue.prototype.$http = http;
  Vue.prototype.$moment = moment;
  
  Promise.resolve()
    .then(() => initI18N(capacities))
    .then(({ VueI18N }) => { 
      options = Object.assign({}, capacities);
      options = Object.assign(options, {VueI18N: VueI18N});

      initApplication( options ) 
    })
    .then(() => initGinger( options ))
    .then(() => initCP( options ))
    .then(() => initLocal( options ))
    .then(() => initModules( options ))
    .then(() => initBody( options ))
    .then(() => initGmap( options ))
    .then(() => initCore( options ))
    .then(() => initReset( options ))
    .then(() => {
      store.dispatch('bootstrap/status', states.APPLICATION_COMPLETE);
    })
}

export default VueBootstrap
